export default __webpack_public_path__ + "static/media/her3.5560602b.svg";